module.exports = __webpack_public_path__ + "co.ed07e7f38e7506b7c84e.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/co.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/co.svg
// module chunks = styles